import { useLazyFetchOrders } from '@@partner:graphql/query/order/allOrders.gql'
import { GQL_ID } from '@@partner:types:graphql'
import OrderCard from '@components/order/orderCard/OrderCard'
import React, { useEffect } from 'react'
import { Loader } from 'rsuite'

type OrdersWithProductProps = {
  productId: GQL_ID
}

export default function OrdersWithProduct ({ productId }: OrdersWithProductProps) {
  const [ loadOrders, { data, loading } ] = useLazyFetchOrders()

  useEffect(() => {
    if (productId) {
      loadOrders({
        variables: {
          filter: {
            fields: [ 'position' ],
            op: 'eq',
            value: productId
          }
        }
      })
    }
  }, [ productId, loadOrders ])

  const orders = data?.orders?.edges || []
  
  return (
    <div>
      {loading ? (
        <Loader content="Загрузка заказов..." />
      ) : orders.length === 0 ? (
        <div className="text-gray-400 text-sm">Заказов с этим товаром не найдено</div>
      ) : (
        orders.map(order => (
          <OrderCard key={order.id} order={order} />
        ))
      )}
    </div>
  )
}